import React from "react";
import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const PublicRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  const isGuest = localStorage.getItem("guest") === "true";

  // 🧭 Guests can always see public pages (login/signup)
  if (isGuest) return children;

  // 🧭 If token exists and valid, redirect to dashboard
  if (token && token.includes(".")) {
    try {
      const decoded = jwtDecode(token);

      // ⏰ Expired token → allow access (they need to log in again)
      if (decoded.exp && decoded.exp * 1000 < Date.now()) {
        localStorage.removeItem("token");
        return children;
      }

      // ✅ Logged in and verified → redirect to dashboard
      if (decoded?.isVerified !== false) {
        return <Navigate to="/dispatch-history" replace />;
      }
    } catch (err) {
      console.warn("JWT decode failed in PublicRoute:", err);
      return children;
    }
  }

  return children;
};

export default PublicRoute;